module.exports = __webpack_public_path__ + "img/other.57f02515.png";